/**
 * Authors: mariushirjanu
 * Created: 22/10/2018
 * Upgraded: 05/10/2022
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslationService } from '../translation/translation.service';

@Component({
  selector: 'mail-notifications',
  template: `
    <a href class="mail-notifications" (click)="onClick($event)" title="linkTitle">
      <i class="fa fa-envelope-o"></i>
      <span class="send">
        <i *ngIf="value" class="successText fa fa-check-circle"></i>
        <i *ngIf="!value" class="errorText fa fa-times-circle"></i>
      </span>
    </a>
  `
})
export class MailNotificationsComponent {
  @Input() public value:boolean;
  @Output() public onChange:EventEmitter<boolean> = new EventEmitter<boolean>();
  public linkTitle:string;

  constructor(
    private translationService:TranslationService
  ) {
    this.linkTitle = this.translationService.instant('GA.GENERAL.SEND_NOTIFICATION');
  }

  public onClick(e:Event):void {
    e.preventDefault();
    this.value = !this.value;
    this.onChange.emit(this.value); // used to notify the parent component that the envelope icon was clicked
  }
}